import { httpClient } from '@shared/api';
import type {
  DialogListResponse,
  DialogMessagesResponse,
  StatsFilters,
  StatsOverview,
} from '../model/types';

/**
 * API статистики диалогов (роутер stats, S-1).
 * Все эндпоинты под /assistants/{assistantId}/stats/...
 */
export const statisticsApi = {
  async getOverview(
    assistantId: string,
    filters: StatsFilters,
  ): Promise<StatsOverview> {
    const { data } = await httpClient.get<StatsOverview>(
      `/assistants/${assistantId}/stats/overview`,
      { params: { platform: filters.platform, period: filters.period } },
    );
    return data;
  },

  async getDialogs(
    assistantId: string,
    filters: StatsFilters,
    limit = 50,
    offset = 0,
  ): Promise<DialogListResponse> {
    const { data } = await httpClient.get<DialogListResponse>(
      `/assistants/${assistantId}/stats/dialogs`,
      {
        params: {
          platform: filters.platform,
          period: filters.period,
          limit,
          offset,
        },
      },
    );
    return data;
  },

  async getDialogMessages(
    assistantId: string,
    dialogId: string,
  ): Promise<DialogMessagesResponse> {
    const { data } = await httpClient.get<DialogMessagesResponse>(
      `/assistants/${assistantId}/stats/dialogs/${dialogId}/messages`,
    );
    return data;
  },
};
